import { useMutation } from '@tanstack/react-query';
import { Divider, Spin } from 'antd';
import { GET_NEW_CUSTOMER_BY_AREA } from 'apis/GraphQL/Queries/customerQuery';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import { Dispatch, useEffect, useState } from 'react';
import CustomerCard from './CustomerCard';
import { IRouteInfo } from 'interfaces/SaleLine';

const NUMBER_OF_CUSTOMER = 3;

interface Iprops {
  data: any[];
  salePlaningId: number;
  routeInfo?: IRouteInfo;
  setNewCustomer: (data: any) => void;
  setData: (data: any) => void;
  setOpenMap: Dispatch<boolean>;
  setLocation: Dispatch<any>;
}

const CUS_TYPE = 'area';

export default function NewCustomer(props: Iprops) {
  const {
    salePlaningId,
    routeInfo,
    data,
    setData,
    setOpenMap,
    setLocation,
    setNewCustomer,
  } = props;
  // const [data, setData] = useState<any>([]);
  const [pageInfo, setPageInfo] = useState<any>({});
  const [skip, setSkip] = useState(0);

  const { isPending: getNewUserArea, mutateAsync: getNewUserByArea } =
    useMutation({
      mutationFn: () =>
        axiosGraphQL.post('/graphql', {
          query: GET_NEW_CUSTOMER_BY_AREA,
          variables: {
            skip,
            take: NUMBER_OF_CUSTOMER,
            input: {
              salePlanningId: salePlaningId,
              cityId: (routeInfo?.cityId || []).join(','),
            },
          },
        }),
      onSuccess: (res: any) => {
        const customers: any[] = [];

        if (res.data?.getProposeCustomerByArea?.items?.length)
          customers.push(
            ...res.data.getProposeCustomerByArea.items.map((item: any) => ({
              ...item,
              id: item.customerId || item.id,
            })),
          );

        if (!customers.length) return;

        setData((prev: any) => ({
          ...prev,
          [CUS_TYPE]: [...prev[CUS_TYPE], ...customers],
        }));
        setSkip((prev: number) => prev + NUMBER_OF_CUSTOMER);
        setPageInfo(res.data.getProposeCustomerByArea.pageInfo);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const handleGetMoreCustomer = () => {
    getNewUserByArea();
  };

  useEffect(() => {
    if (!routeInfo?.cityId) return;

    getNewUserByArea();
  }, [getNewUserByArea, routeInfo?.cityId, setData]);

  return (
    <Spin spinning={getNewUserArea}>
      <div
        style={{
          flexGrow: 0,
          overflow: 'auto',
          minHeight: '400px',
          maxHeight: '400px',
        }}
      >
        {(data || []).length == 0 ? (
          'Không có khách hàng mới trong khu vực'
        ) : (
          <CustomerCard
            data={data}
            setData={setData}
            setOpenMap={setOpenMap}
            setLocation={setLocation}
            handleAddCusomer={setNewCustomer}
            cusType={CUS_TYPE}
          />
        )}
      </div>

      <Divider />
      {pageInfo.hasNextPage && (
        <button onClick={handleGetMoreCustomer}>
          <span style={{ color: '#003056', fontWeight: 'bold' }}>
            Đề xuất thêm
          </span>
        </button>
      )}
    </Spin>
  );
}
